import {QueryFunctionContext} from 'react-query';
import request from '../../axios';

export const getLabTests = async (ctx: QueryFunctionContext) => {
  const params = ctx.queryKey[1];
  const {data}: {data: Array<ILabTest>} = await request.get(
    `/api/v2/store/lab-test-list?activity_field=` + params,
  );
  return data;
};
